import React from 'react';
import ServicePage from '../components/ServicePage';
import services from '../data/services.json';

export default function Page() { return <ServicePage service={services.autorepairs} />; }
